
import axios from "axios";

import "../styles/AerospaceFaqSection.css";

import config from "../config/config.json";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

import React, { useState } from 'react';

function Naics() {
  const [inputValue, setInputValue] = useState('');
  const [data, setData] = useState([]);
  const [error, setError] = useState('');

  const handleSearch = async () => {
    if (!/^\d{2,6}\*{0,4}$/.test(inputValue)) {
      setError('Please enter a valid NAICS pattern like 22** or 111***');
      setData([]);
      return;
    }

    setError('');
    try {
      const response = await fetch(config.APP_URL +`/technology/naics/${inputValue}`);
      if (!response.ok) throw new Error('Failed to fetch data');
      const result = await response.json();
      setData(result);
    } catch (err) {
      setError('Invalid NAICS code. Please check if you missed anything.');
      console.error(err);
    }
  };

  return (  
 <>
      <LandingSection
        data={{ imageName: "about.webp", title: "🔍 NAICS Code Finder" }}
      />

      <div className="utah-at-a-glance-section">
        <div className="utah-at-a-glance-intro">
          <div className="utah-at-a-glance-intro-sec1">
            <h2 className="text-3xl font-bold text-gray-800 text-center mt-6">
            NAICS Code
            </h2>
          </div>
          <div className="utah-at-a-glance-intro-sec2">
           <p>
  Empowering Utahns with accessible, visual, and reliable data. Whether you're researching, planning, or exploring—our platform helps you make sense of it all.
</p>
          </div>
        </div>
      </div>

<div className="p-6 mt-[8rem] lg:mt-[12rem] max-w-[90rem] mx-auto">

  <div className="flex flex-col lg:flex-row gap-10">

    {/* LEFT COLUMN: Search + Table */}
    <div className="flex-1 w-full">
      <h2 className="text-2xl font-bold text-center text-indigo-700 mb-4">
        🔍 NAICS Code Finder
      </h2>

      {/* Input + Button */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
        className="flex flex-col md:flex-row items-center gap-4 mb-4"
      >
        <input
          type="text"
          placeholder="Enter NAICS code like 22**"
          value={inputValue}
      onChange={(e) => {
    setInputValue(e.target.value);
    setData([]); // Clear previous data
  }}
          className="border border-gray-300 px-4 py-2 rounded-md w-full shadow-sm"
        />
        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-md transition-all shadow"
        >
          Find
        </button>
      </form>

      {/* Error */}
      {error && <p className="text-red-600 mb-4">{error}</p>}

      {/* Table */}
      {data.length > 0 && (
        <div className="overflow-x-auto border rounded-lg shadow">
          <table className="min-w-full table-auto bg-white border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th className="border px-4 py-2 text-left">NAICS Code</th>
                <th className="border px-4 py-2 text-left">Industry Label</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.code} className="hover:bg-gray-50">
                  <td className="border px-4 py-2">{item.code}</td>
                  <td className="border px-4 py-2">{item.label}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>

    {/* RIGHT COLUMN: Toolkit */}
    <div className="w-full lg:w-[400px]" style={{ marginTop: '3.5%' }}>
      <div className="bg-yellow-50 border border-yellow-300 text-yellow-800 p-4 rounded-md shadow-sm text-sm leading-relaxed">
        <p className="font-semibold mb-1">How to use NAICS Code Search:</p>
        <ul className="list-disc list-inside space-y-1">
          <li><code className='text-blue-800'>11</code> → Show exact match for 2-digit code 11</li>
          <li><code className='text-blue-800'>11*</code> → Show all 3-digit codes that start with 11 (like 111, 112), plus 11 itself</li>
          <li><code className='text-blue-800'>11**</code> → Show all codes starting with 11, up to 4-digit level (e.g., 111, 1111)</li>
          <li><code className='text-blue-800'>111***</code> → Show all codes starting with 111, up to 6-digit level</li>
          <li><code className='text-blue-800'>1111*</code> → Show all 5-digit codes that start with 1111 (like 11111, 11112), plus 1111</li>
          <li><code className='text-blue-800'>11111*</code> → Show all 6-digit codes that start with 11111 (like 111110, 111120), plus 11111</li>
          
        </ul>
        <p className="mt-2 italic">
          Note: Use <code className='text-blue-800'>*</code>, <code className='text-blue-800'>**</code>, <code className='text-blue-800'>***</code> to expand the search depth.
        </p>
      </div>
    </div>

  </div>
</div>

<Footer />
    </>




  );
}

export default Naics;
